import { FileUploadStatus } from "@explorance/mly-types";
import { BE_IMPORT_TASK_PROGRESS_MULTIPLIER } from "assets/constants/import";
import { useEffect, useState } from "react";
import { getFileById } from "services/files";
import { useAppDispatch, useAppSelector } from "store";
import { setImportProgressPercentage } from "store/analysisSettings/dataSourceSlice";

export const useDataSourceProgressBar = () => {
  const dispatch = useAppDispatch();
  const state = useAppSelector((state) => state.dataSource);

  const [importBuffer, setImportBuffer] = useState<number>(0);
  const [importProgress, setImportProgress] = useState<number>(0);

  useEffect(() => {
    if (state.importProgressPercentage > importProgress && importBuffer > 0) {
      const timeoutId = setTimeout(() => {
        setImportProgress((prev) => prev + importBuffer);
      }, 500);
      return () => clearTimeout(timeoutId);
    }
  }, [importProgress, importBuffer]); // eslint-disable-line

  useEffect(() => {
    if (!state.importModalFileId) return;
    getFileById(state.importModalFileId).then((res) => {
      if (res.data.uploadStatus !== FileUploadStatus.WaitingForInput) {
        setImportProgress(res.data.progress);
      }
    });
  }, []); //eslint-disable-line

  useEffect(() => {
    let timer;
    if (state.importModalFileId && state.importModalOpen) {
      timer = setInterval(() => {
        getFileById(state.importModalFileId).then((res) => {
          if (res.data.uploadStatus === FileUploadStatus.WaitingForInput) {
            clearInterval(timer);
            return;
          } else {
            dispatch(
              setImportProgressPercentage(res.data.progress * BE_IMPORT_TASK_PROGRESS_MULTIPLIER)
            );
            setImportBuffer(
              (res.data.progress * BE_IMPORT_TASK_PROGRESS_MULTIPLIER - importProgress) / 10
            );
          }
        });
      }, 2000);
      return () => {
        clearInterval(timer);
      };
    }
  }, [state.importModalFileId]); // eslint-disable-line

  return { importProgress };
};
